/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProjectsAccessVM { 
    id?: number;
    userId?: number;
    projectId?: number | null;
    level1?: string | null;
    level2?: string | null;
    level3?: string | null;
    level4?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    schoolId?: number | null;
    checkoutdevice?: boolean;
    registerDevice?: boolean;
    scanDevice?: boolean;
    registerSchool?: boolean | null;
    isAdmin?: boolean | null;
}

